import React, { useState, createContext } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { initReactI18next, useTranslation,I18nextProvider } from 'react-i18next';
import i18n from "i18next";
import reportWebVitals from './reportWebVitals';
import App from './App';
// Css
import "lightgallery.js/dist/css/lightgallery.css";
import './assets/css/bootstrap.min.css';
import "./assets/css/slick.css";
import "./assets/css/slick.css";
import './assets/css/magnific-popup.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/animate.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/flaticon.css';
import './assets/css/default.css';
import './assets/scss/style.scss';
import "swiper/swiper.scss"
import "swiper/modules/pagination/pagination.scss"
import "swiper/modules/navigation/navigation.scss";
import './index.css';
import en from "./configs/en.json"
import it from "../src/configs/it.json"

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en
            },
            it: {
                translation: it
            }
        },
        lng: 'it',
        fallbackLng: 'it',
        interpolation: {
            escapeValue: false,
        },
    });




if (process.env.REACT_APP_ENV !== "development") console.log = () => {};

ReactDOM.render(
    <BrowserRouter>

        <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider>

    </BrowserRouter>,
    document.getElementById('miranda')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
